(() => {
  'use strict';

  const STORAGE_KEY = 'gravex_selected_vehicle';
  const body = document.body;
  const vehicleSource = document.getElementById('GvxVehicleData');
  let vehicles = [];

  try {
    vehicles = JSON.parse(vehicleSource?.textContent || '[]').filter((vehicle) => (
      vehicle && vehicle.key && vehicle.make && vehicle.model && vehicle.generation
    ));
  } catch (error) {
    vehicles = [];
  }

  const unique = (items) => [...new Set(items.filter(Boolean))];

  const savedVehicle = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!value?.key) return null;
      if (value.savedAt && Date.now() - value.savedAt > 15552000000) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      const vehicle = vehicles.find((item) => item.key === value.key) || null;
      if (!vehicle) localStorage.removeItem(STORAGE_KEY);
      return vehicle;
    } catch (error) {
      return null;
    }
  };

  const vehicleLabel = (vehicle) => {
    if (!vehicle) return 'No vehicle selected';
    return [vehicle.make, vehicle.model, vehicle.generation].filter(Boolean).join(' · ');
  };

  const saveVehicle = (vehicle) => {
    if (!vehicle) return;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ key: vehicle.key, schema: 1, savedAt: Date.now() }));
    } catch (error) {
      // Private browsing can block localStorage. Navigation still works.
    }
    document.dispatchEvent(new CustomEvent('gvx:vehicle-change', { detail: vehicle }));
  };

  const clearVehicle = () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Ignore storage restrictions.
    }
    document.dispatchEvent(new CustomEvent('gvx:vehicle-change', { detail: null }));
  };

  const fillSelect = (select, values, placeholder) => {
    if (!select) return;
    const option = document.createElement('option');
    option.value = '';
    option.textContent = placeholder;
    select.replaceChildren(option);
    values.forEach((value) => {
      const item = document.createElement('option');
      item.value = typeof value === 'object' ? value.value : value;
      item.textContent = typeof value === 'object' ? value.label : value;
      select.append(item);
    });
  };

  class VehicleFinder {
    constructor(root) {
      if (root.dataset.gvxReady === 'true') return;
      root.dataset.gvxReady = 'true';
      this.root = root;
      this.make = root.querySelector('[data-gvx-make]');
      this.model = root.querySelector('[data-gvx-model]');
      this.generation = root.querySelector('[data-gvx-generation]');
      this.submit = root.querySelector('[data-gvx-submit]');
      if (!this.make || !this.model || !this.generation || !this.submit) return;
      this.bind();
      this.reset();
      this.prefill(savedVehicle());
    }

    bind() {
      this.make.addEventListener('change', () => this.onMake());
      this.model.addEventListener('change', () => this.onModel());
      this.generation.addEventListener('change', () => this.onGeneration());
      this.root.addEventListener('submit', (event) => this.onSubmit(event));
      document.addEventListener('gvx:vehicle-change', (event) => this.prefill(event.detail));
    }

    reset() {
      const makes = unique(vehicles.map((vehicle) => vehicle.make));
      fillSelect(this.make, makes, makes.length ? 'Select brand' : 'Vehicle catalogue connecting');
      this.make.disabled = makes.length === 0;
      fillSelect(this.model, [], 'Select model');
      fillSelect(this.generation, [], 'Select generation');
      this.model.disabled = true;
      this.generation.disabled = true;
      this.submit.disabled = true;
    }

    onMake() {
      const models = unique(vehicles.filter((vehicle) => vehicle.make === this.make.value).map((vehicle) => vehicle.model));
      fillSelect(this.model, models, 'Select model');
      fillSelect(this.generation, [], 'Select generation');
      this.model.disabled = !this.make.value || models.length === 0;
      this.generation.disabled = true;
      this.submit.disabled = true;
    }

    onModel() {
      const generations = vehicles
        .filter((vehicle) => vehicle.make === this.make.value && vehicle.model === this.model.value)
        .map((vehicle) => ({ value: vehicle.key, label: vehicle.generation }));
      fillSelect(this.generation, generations, 'Select generation');
      this.generation.disabled = !this.model.value || generations.length === 0;
      this.submit.disabled = true;
      if (generations.length === 1) {
        this.generation.value = generations[0].value;
        this.onGeneration();
      }
    }

    onGeneration() {
      const vehicle = this.current();
      this.submit.disabled = !vehicle || !vehicle.url;
      this.submit.title = vehicle && !vehicle.url ? 'This vehicle route is not connected yet' : '';
    }

    current() {
      return vehicles.find((vehicle) => vehicle.key === this.generation.value) || null;
    }

    prefill(vehicle) {
      if (!vehicle || !vehicles.some((item) => item.key === vehicle.key)) {
        this.reset();
        return;
      }
      this.make.value = vehicle.make;
      this.onMake();
      this.model.value = vehicle.model;
      this.onModel();
      this.generation.value = vehicle.key;
      this.onGeneration();
    }

    onSubmit(event) {
      event.preventDefault();
      const vehicle = this.current();
      if (!vehicle || !vehicle.url) return;
      saveVehicle(vehicle);
      window.location.assign(vehicle.url);
    }
  }

  const updateVehicleContext = (vehicle = savedVehicle()) => {
    const label = vehicleLabel(vehicle);
    document.querySelectorAll('[data-gvx-saved-label], [data-gvx-lock-label]').forEach((node) => {
      node.textContent = label;
    });

    document.querySelectorAll('[data-gvx-lock-action]').forEach((node) => {
      const vehicleUrl = vehicle && typeof vehicle.url === 'string' ? vehicle.url : '';
      node.textContent = vehicleUrl ? 'Shop this vehicle' : 'Select vehicle';
      node.href = vehicleUrl || node.dataset.gvxLockDefaultUrl || '/#GvxHeroFinder';
    });

    document.querySelectorAll('[data-gvx-header-vehicle-label]').forEach((node) => {
      node.textContent = vehicle ? `${vehicle.make} ${vehicle.model} ${vehicle.generation}` : 'Shop by vehicle';
    });

    document.querySelectorAll('[data-gvx-clear-vehicle]').forEach((node) => {
      node.hidden = !vehicle;
    });

    document.querySelectorAll('[data-gvx-contact-vehicle]').forEach((input) => {
      if (vehicle && !input.value) input.value = label;
    });

    const vehicleFields = {
      '[data-gvx-contact-brand]': vehicle?.make,
      '[data-gvx-contact-model]': vehicle?.model,
      '[data-gvx-contact-generation]': vehicle?.generation
    };
    Object.entries(vehicleFields).forEach(([selector, value]) => {
      document.querySelectorAll(selector).forEach((input) => {
        if (value && !input.value) input.value = value;
      });
    });

    document.querySelectorAll('[data-gvx-footer-vehicle]').forEach((footer) => {
      const kicker = footer.querySelector('[data-gvx-footer-kicker]');
      const title = footer.querySelector('[data-gvx-footer-title]');
      const copy = footer.querySelector('[data-gvx-footer-copy]');
      const button = footer.querySelector('[data-gvx-footer-button]');
      const link = footer.querySelector('[data-gvx-footer-link]');
      if (vehicle) {
        if (kicker) kicker.textContent = 'Your saved vehicle';
        if (title) title.textContent = `Continue with your ${vehicle.make} ${vehicle.model}`;
        if (copy) copy.textContent = `Browse the catalogue route for ${vehicle.generation}.`;
        if (button) button.textContent = 'View vehicle parts';
        if (link && vehicle.url) link.href = vehicle.url;
      } else {
        if (kicker) kicker.textContent = 'Shop by vehicle';
        if (title) title.textContent = 'Start with your car';
        if (copy) copy.textContent = 'Set Brand, Model and Generation once. GRAVEX remembers your choice while you browse.';
        if (button) button.textContent = 'Select your car';
        if (link && link.dataset.defaultHref) link.href = link.dataset.defaultHref;
      }
    });

    document.querySelectorAll('[data-gvx-collection-vehicle-context]').forEach((context) => {
      const state = context.querySelector('[data-gvx-collection-state]');
      const selection = context.querySelector('[data-gvx-collection-selection]');
      const savedRoute = context.querySelector('[data-gvx-collection-saved-route]');
      const change = context.querySelector('[data-gvx-collection-change]');
      let collectionVehicles = [];

      try {
        collectionVehicles = JSON.parse(context.querySelector('[data-gvx-collection-vehicles]')?.textContent || '[]');
      } catch (error) {
        collectionVehicles = [];
      }

      const isCurrentRoute = Boolean(vehicle && collectionVehicles.some((item) => (
        item.key === vehicle.key || item.handle === vehicle.key
      )));

      if (!vehicle) {
        context.dataset.routeState = 'empty';
        if (state) state.textContent = 'Vehicle catalogue';
        if (selection) selection.textContent = 'Select a vehicle to keep your route clear';
        if (savedRoute) savedRoute.hidden = true;
        if (change) change.textContent = 'Select';
        return;
      }

      if (isCurrentRoute) {
        context.dataset.routeState = 'current';
        if (state) state.textContent = 'Saved catalogue route';
        if (selection) selection.textContent = vehicleLabel(vehicle);
        if (savedRoute) savedRoute.hidden = true;
        if (change) change.textContent = 'Change';
        return;
      }

      context.dataset.routeState = 'mismatch';
      if (state) state.textContent = 'Different catalogue route';
      if (selection) selection.textContent = `Saved: ${vehicleLabel(vehicle)}`;
      if (savedRoute) {
        savedRoute.hidden = !vehicle.url;
        if (vehicle.url) savedRoute.href = vehicle.url;
      }
      if (change) change.textContent = 'Change';
    });
  };

  const initVehicleClearActions = (scope = document) => {
    scope.querySelectorAll('[data-gvx-clear-vehicle]').forEach((node) => {
      if (node.dataset.gvxReady === 'true') return;
      node.dataset.gvxReady = 'true';
      node.addEventListener('click', clearVehicle);
    });
  };

  const initFinders = (scope = document) => {
    scope.querySelectorAll('[data-gvx-finder]').forEach((root) => new VehicleFinder(root));
  };

  const button = (label, onClick, active = false, disabled = false) => {
    const node = document.createElement('button');
    node.type = 'button';
    node.textContent = label;
    node.classList.toggle('is-active', active);
    node.disabled = disabled;
    node.addEventListener('click', onClick);
    return node;
  };

  const focusableWithin = (root) => [...root.querySelectorAll(
    'summary, a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )].filter((node) => node.tabIndex >= 0 && !node.hidden && node.getAttribute('aria-hidden') !== 'true' && node.getClientRects().length > 0);

  const trapTab = (event, root) => {
    if (event.key !== 'Tab') return;
    const nodes = focusableWithin(root);
    if (!nodes.length) {
      event.preventDefault();
      root.focus?.();
      return;
    }
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === root)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const initMegaMenus = (scope = document) => {
    scope.querySelectorAll('[data-gvx-shell]').forEach((shell) => {
      if (shell.dataset.gvxMegaReady === 'true') return;
      shell.dataset.gvxMegaReady = 'true';
      const toggle = shell.querySelector('[data-gvx-mega-toggle]');
      const mega = shell.querySelector('[data-gvx-mega]');
      const makesSlot = shell.querySelector('[data-gvx-mega-makes]');
      const modelsSlot = shell.querySelector('[data-gvx-mega-models]');
      const generationsSlot = shell.querySelector('[data-gvx-mega-generations]');
      const reset = shell.querySelector('[data-gvx-reset-vehicle]');
      const viewAll = shell.querySelector('[data-gvx-mega-view-all]');
      let selectedMake = savedVehicle()?.make || vehicles[0]?.make || '';
      let selectedModel = savedVehicle()?.model || '';

      const emptyState = (slot, copy) => {
        if (!slot) return;
        const message = document.createElement('p');
        message.className = 'gvx-mega__empty';
        message.textContent = copy;
        slot.replaceChildren(message);
      };

      const close = (restoreFocus = false) => {
        if (!mega || mega.hidden) return;
        mega.hidden = true;
        toggle?.setAttribute('aria-expanded', 'false');
        body.classList.remove('gvx-lock-scroll');
        if (restoreFocus) toggle?.focus();
      };

      const open = () => {
        if (!mega) return;
        closeMobile();
        window.themeCore?.EventBus?.emit('Toggle:searchTogglePopup:close');
        mega.hidden = false;
        toggle?.setAttribute('aria-expanded', 'true');
        body.classList.add('gvx-lock-scroll');
        renderMakes();
        requestAnimationFrame(() => focusableWithin(mega)[0]?.focus());
      };

      const renderMakes = () => {
        if (!makesSlot) return;
        makesSlot.replaceChildren();
        const makes = unique(vehicles.map((vehicle) => vehicle.make));
        if (!makes.length) {
          emptyState(makesSlot, 'Vehicle catalogue is being connected.');
          emptyState(modelsSlot, 'Models appear after a brand route is available.');
          emptyState(generationsSlot, 'Generations appear after a model route is available.');
          if (reset) reset.disabled = true;
          if (viewAll) {
            viewAll.href = viewAll.dataset.emptyHref || '#GvxHeroFinder';
            viewAll.textContent = 'Browse all parts';
          }
          return;
        }
        if (!makes.includes(selectedMake)) selectedMake = makes[0] || '';
        if (reset) reset.disabled = false;
        if (viewAll) {
          viewAll.href = viewAll.dataset.catalogueHref || viewAll.href;
          viewAll.textContent = 'View all vehicles';
        }
        makes.forEach((make) => {
          makesSlot.append(button(make, () => {
            selectedMake = make;
            selectedModel = '';
            renderMakes();
          }, selectedMake === make));
        });
        renderModels();
      };

      const renderModels = () => {
        if (!modelsSlot) return;
        const models = unique(vehicles.filter((vehicle) => vehicle.make === selectedMake).map((vehicle) => vehicle.model));
        if (!models.includes(selectedModel)) selectedModel = models[0] || '';
        modelsSlot.replaceChildren();
        models.forEach((model) => {
          modelsSlot.append(button(model, () => {
            selectedModel = model;
            renderModels();
          }, selectedModel === model));
        });
        renderGenerations();
      };

      const renderGenerations = () => {
        if (!generationsSlot) return;
        generationsSlot.replaceChildren();
        vehicles
          .filter((vehicle) => vehicle.make === selectedMake && vehicle.model === selectedModel)
          .forEach((vehicle) => {
            generationsSlot.append(button(vehicle.generation, () => {
              if (!vehicle.url) return;
              saveVehicle(vehicle);
              window.location.assign(vehicle.url);
            }, savedVehicle()?.key === vehicle.key, !vehicle.url));
          });
      };

      toggle?.addEventListener('click', (event) => {
        event.preventDefault();
        if (mega?.hidden) open(); else close();
      });
      shell.querySelectorAll('[data-gvx-mega-close]').forEach((node) => node.addEventListener('click', () => close(true)));
      mega?.addEventListener('keydown', (event) => trapTab(event, mega));
      reset?.addEventListener('click', clearVehicle);
      document.addEventListener('gvx:vehicle-change', (event) => {
        selectedMake = event.detail?.make || vehicles[0]?.make || '';
        selectedModel = event.detail?.model || '';
        if (mega && !mega.hidden) renderMakes();
      });

      const mobileToggle = shell.querySelector('[data-gvx-mobile-toggle]');
      const mobileMenu = shell.querySelector('[data-gvx-mobile-menu]');
      const closeMobile = (restoreFocus = false) => {
        if (!mobileMenu || mobileMenu.hidden) return;
        mobileMenu.hidden = true;
        mobileToggle?.setAttribute('aria-expanded', 'false');
        mobileToggle?.setAttribute('aria-label', 'Open menu');
        body.classList.remove('gvx-lock-scroll');
        if (restoreFocus) mobileToggle?.focus();
      };
      mobileToggle?.addEventListener('click', () => {
        if (!mobileMenu) return;
        const opening = mobileMenu.hidden;
        if (opening) {
          close();
          window.themeCore?.EventBus?.emit('Toggle:searchTogglePopup:close');
        }
        mobileMenu.hidden = !opening;
        mobileToggle.setAttribute('aria-expanded', String(opening));
        mobileToggle.setAttribute('aria-label', opening ? 'Close menu' : 'Open menu');
        body.classList.toggle('gvx-lock-scroll', opening);
        if (opening) requestAnimationFrame(() => focusableWithin(mobileMenu)[0]?.focus());
      });
      mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobile));
      mobileMenu?.addEventListener('keydown', (event) => trapTab(event, mobileMenu));
      window.themeCore?.EventBus?.listen('Toggle:searchTogglePopup:open', () => {
        close();
        closeMobile();
      });

      const mobileViewport = window.matchMedia('(max-width: 989px)');
      mobileViewport.addEventListener('change', (event) => {
        if (event.matches) close();
        else closeMobile();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const wasOpen = mega && !mega.hidden;
        const mobileWasOpen = mobileMenu && !mobileMenu.hidden;
        close(wasOpen);
        closeMobile(mobileWasOpen);
      });
    });
  };

  const initContactPanel = () => {
    const panel = document.querySelector('[data-gvx-contact-panel]');
    const dialog = panel?.querySelector('[data-gvx-contact-dialog]');
    const openers = [...document.querySelectorAll('[data-gvx-contact-open]')];
    if (!panel || !dialog || !openers.length || panel.dataset.gvxReady === 'true') return;
    panel.dataset.gvxReady = 'true';
    let returnFocus = null;

    const open = (trigger) => {
      returnFocus = trigger;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      openers.forEach((node) => node.setAttribute('aria-expanded', 'true'));
      body.classList.add('gvx-lock-scroll');
      requestAnimationFrame(() => (focusableWithin(dialog)[0] || dialog).focus());
    };
    const close = () => {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      openers.forEach((node) => node.setAttribute('aria-expanded', 'false'));
      body.classList.remove('gvx-lock-scroll');
      returnFocus?.focus();
    };
    openers.forEach((node) => node.addEventListener('click', () => open(node)));
    panel.querySelectorAll('[data-gvx-contact-close]').forEach((node) => node.addEventListener('click', close));
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      }
      trapTab(event, dialog);
    });
  };

  const initProductSystem = (scope = document) => {
    scope.querySelectorAll('[data-gvx-product-system]').forEach((system) => {
      if (system.dataset.gvxReady === 'true') return;
      system.dataset.gvxReady = 'true';
      const lock = system.querySelector('[data-gvx-product-lock]');
      const state = system.querySelector('[data-gvx-product-state]');
      const label = system.querySelector('[data-gvx-product-vehicle]');
      const expected = system.querySelector('[data-gvx-product-expected]');
      const action = system.querySelector('[data-gvx-product-action]');
      const cartVehicle = system.querySelector('[data-gvx-cart-vehicle]');
      const cartVehicleKey = system.querySelector('[data-gvx-cart-vehicle-key]');
      const container = system.closest('[data-js-product-container]');
      const form = container?.querySelector('[data-js-product-form]');
      const fitmentVerified = system.dataset.gvxFitmentVerified === 'true';
      const supplierListed = system.dataset.gvxSupplierListed === 'true';
      let compatible = [];
      let supplierCompatible = [];
      try { compatible = JSON.parse(system.querySelector('[data-gvx-compatible-generations]')?.textContent || '[]'); } catch (error) { compatible = []; }
      try { supplierCompatible = JSON.parse(system.querySelector('[data-gvx-supplier-generations]')?.textContent || '[]'); } catch (error) { supplierCompatible = []; }
      const vehicleSpecific = system.dataset.gvxVehicleSpecific === 'true';
      const routingCompatibility = compatible.length ? compatible : supplierCompatible;
      const expectedFitment = unique(routingCompatibility.map((item) => item.label));
      const expectedFitmentLabel = expectedFitment.length > 3
        ? `${expectedFitment.slice(0, 3).join(', ')} +${expectedFitment.length - 3}`
        : expectedFitment.join(', ');
      let purchaseAllowed = !vehicleSpecific;
      let confirmedVehicle = null;

      const currentVariant = () => {
        try {
          return JSON.parse(container?.querySelector('[data-selected-variant]')?.textContent || 'null');
        } catch (error) {
          return null;
        }
      };

      const addButtons = () => [...(container?.querySelectorAll(
        '[data-js-product-form] [type="submit"], [data-js-product-form] .shopify-payment-button__button, .js-sticky-add-to-cart-button'
      ) || [])];

      const clearCartVehicle = () => {
        confirmedVehicle = null;
        [cartVehicle, cartVehicleKey].forEach((input) => {
          if (!input) return;
          input.value = '';
          input.disabled = true;
        });
      };

      const confirmCartVehicle = (vehicle) => {
        confirmedVehicle = vehicle;
        if (cartVehicle) {
          cartVehicle.value = vehicleLabel(vehicle);
          cartVehicle.disabled = false;
        }
        if (cartVehicleKey) {
          cartVehicleKey.value = vehicle.key;
          cartVehicleKey.disabled = false;
        }
      };

      const showExpectedFitment = (copy) => {
        if (!expected) return;
        expected.textContent = copy || '';
        expected.hidden = !copy;
      };

      const syncPurchaseState = () => {
        const variant = currentVariant();
        if (container) container.dataset.gvxFitmentBlocked = purchaseAllowed ? 'false' : 'true';
        addButtons().forEach((addButton) => {
          if (!purchaseAllowed) {
            addButton.disabled = true;
            addButton.dataset.gvxFitmentBlocked = 'true';
            addButton.setAttribute('aria-describedby', lock?.id || '');
          } else if (addButton.dataset.gvxFitmentBlocked === 'true') {
            delete addButton.dataset.gvxFitmentBlocked;
            addButton.removeAttribute('aria-describedby');
            if (variant) addButton.disabled = !variant.available;
          }
        });
      };

      const render = (vehicle = savedVehicle()) => {
        if (!lock || !state || !label || !action) return;
        purchaseAllowed = !vehicleSpecific;
        clearCartVehicle();
        system.dataset.gvxPurchaseState = vehicleSpecific ? 'empty' : 'generic';
        if (!vehicle) {
          lock.dataset.state = 'empty';
          state.textContent = vehicleSpecific ? 'Vehicle selection required' : 'Vehicle check';
          label.textContent = 'No vehicle selected';
          action.textContent = 'Select vehicle';
          showExpectedFitment(vehicleSpecific
            ? (expectedFitmentLabel ? `Fits: ${expectedFitmentLabel}` : 'Select a vehicle to confirm fitment.')
            : '');
          syncPurchaseState();
          return;
        }
        label.textContent = vehicleLabel(vehicle);
        action.textContent = 'Change vehicle';

        if (!routingCompatibility.length) {
          lock.dataset.state = 'unknown';
          system.dataset.gvxPurchaseState = vehicleSpecific ? 'unknown' : 'generic';
          state.textContent = vehicleSpecific ? 'Compatibility not confirmed' : 'Vehicle check';
          showExpectedFitment(vehicleSpecific ? 'Manual fitment confirmation is required before ordering.' : '');
          syncPurchaseState();
          return;
        }

        const matched = routingCompatibility.some((item) => item.key === vehicle.key || item.handle === vehicle.key);
        if (matched && compatible.length && fitmentVerified) {
          lock.dataset.state = 'match';
          system.dataset.gvxPurchaseState = 'match';
          state.textContent = 'Confirmed for your selected vehicle';
          showExpectedFitment('');
          purchaseAllowed = true;
          confirmCartVehicle(vehicle);
        } else if (matched) {
          lock.dataset.state = 'unknown';
          system.dataset.gvxPurchaseState = 'unknown';
          state.textContent = 'Vehicle found · confirmation required';
          showExpectedFitment(`Expected fitment: ${expectedFitmentLabel || vehicleLabel(vehicle)}`);
        } else {
          lock.dataset.state = 'mismatch';
          system.dataset.gvxPurchaseState = 'mismatch';
          state.textContent = 'Vehicle mismatch · ordering blocked';
          showExpectedFitment(expectedFitmentLabel ? `Fits: ${expectedFitmentLabel}` : 'Choose a compatible vehicle.');
        }
        syncPurchaseState();
      };

      form?.addEventListener('submit', (event) => {
        if (purchaseAllowed) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        lock?.focus();
      }, true);

      form?.addEventListener('formdata', (event) => {
        if (!confirmedVehicle) {
          event.formData.delete('properties[Selected vehicle]');
          event.formData.delete('properties[_Vehicle key]');
          return;
        }
        event.formData.set('properties[Selected vehicle]', vehicleLabel(confirmedVehicle));
        event.formData.set('properties[_Vehicle key]', confirmedVehicle.key);
      });

      const bindVariantEvents = () => {
        if (!container || system.dataset.gvxVariantBound === 'true' || !window.themeCore?.EventBus) return;
        system.dataset.gvxVariantBound = 'true';
        const sectionId = container.dataset.sectionId;
        if (sectionId) window.themeCore.EventBus.listen(`pdp:section-${sectionId}:change-variant`, syncPurchaseState);
      };

      render();
      bindVariantEvents();
      document.addEventListener('theme:all:loaded', bindVariantEvents, { once: true });
      document.addEventListener('gvx:vehicle-change', (event) => render(event.detail));
    });
  };

  const initReveals = (scope = document) => {
    const nodes = [...scope.querySelectorAll('[data-gvx-reveal]:not([data-gvx-reveal-ready])')];
    if (!nodes.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => { node.dataset.gvxRevealReady = 'true'; node.classList.add('is-revealed'); });
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8%', threshold: .08 });
    nodes.forEach((node) => { node.dataset.gvxRevealReady = 'true'; observer.observe(node); });
  };

  const initFooterAccordions = (scope = document) => {
    scope.querySelectorAll('[data-gvx-footer-toggle]').forEach((heading) => {
      if (heading.dataset.gvxReady === 'true') return;
      heading.dataset.gvxReady = 'true';
      const column = heading.closest('.gvx-footer__column');
      const mobile = window.matchMedia('(max-width: 767px)');
      const syncMode = () => {
        if (mobile.matches) {
          column.classList.add('gvx-footer-ready');
          heading.setAttribute('tabindex', '0');
          heading.setAttribute('role', 'button');
          heading.setAttribute('aria-expanded', String(column.classList.contains('is-open')));
        } else {
          column.classList.remove('gvx-footer-ready', 'is-open');
          heading.removeAttribute('tabindex');
          heading.removeAttribute('role');
          heading.removeAttribute('aria-expanded');
        }
      };
      const toggle = () => {
        if (!mobile.matches) return;
        const opening = !column.classList.contains('is-open');
        column.classList.toggle('is-open', opening);
        heading.setAttribute('aria-expanded', String(opening));
      };
      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
      });
      mobile.addEventListener?.('change', syncMode);
      syncMode();
    });
  };

  const initNativeSearch = () => {
    const search = document.getElementById('headerPopupSearch');
    const Toggle = window.themeCore?.utils?.Toggle;
    if (!search || !Toggle || search.dataset.gvxToggleReady === 'true') return;
    search.dataset.gvxToggleReady = 'true';
    Toggle({
      toggleSelector: 'searchTogglePopup',
      toggleTabIndex: true,
      elementToFocus: search.querySelector('.js-predictive-search-input')
    }).init();
  };

  const initCartCount = () => {
    if (body.dataset.gvxCartCountReady === 'true' || !window.themeCore?.EventBus) return;
    body.dataset.gvxCartCountReady = 'true';
    window.themeCore.EventBus.listen('cart:updated', (cart) => {
      if (!Number.isFinite(Number(cart?.item_count))) return;
      const count = Number(cart.item_count);
      document.querySelectorAll('.js-header-cart-item-count').forEach((node) => {
        node.textContent = count > 99 ? '99+' : String(count);
        node.setAttribute('aria-label', `${count} ${count === 1 ? 'item' : 'items'}`);
      });
    });
  };

  const initHeaderScroll = () => {
    const headers = document.querySelectorAll('[data-gvx-header]');
    const shell = document.querySelector('[data-gvx-shell]');
    let measuredHeight = 0;
    const updateScrollState = () => {
      headers.forEach((header) => header.classList.toggle('is-scrolled', window.scrollY > 12));
    };
    const measureHeader = () => {
      const stackHeight = Math.round(shell?.getBoundingClientRect().height || 0);
      if (stackHeight > 0 && stackHeight !== measuredHeight) {
        measuredHeight = stackHeight;
        document.documentElement.style.setProperty('--gvx-header-stack-height', `${stackHeight}px`);
      }
    };
    updateScrollState();
    measureHeader();
    window.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('resize', measureHeader, { passive: true });
    if (shell && 'ResizeObserver' in window) new ResizeObserver(measureHeader).observe(shell);
  };

  const init = (scope = document) => {
    initFinders(scope);
    initVehicleClearActions(scope);
    initMegaMenus(scope);
    initProductSystem(scope);
    initReveals(scope);
    initFooterAccordions(scope);
    updateVehicleContext();
  };

  document.addEventListener('gvx:vehicle-change', (event) => updateVehicleContext(event.detail));
  document.addEventListener('DOMContentLoaded', () => {
    init();
    initContactPanel();
    initHeaderScroll();
    initNativeSearch();
    initCartCount();
  });
  document.addEventListener('theme:all:loaded', () => {
    initNativeSearch();
    initCartCount();
  }, { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

